export const environment: Environment = {
  production: false,
  apiKey: 'AIzaSyCT4y1sj0qw9E-qpaII5FG6eeZkCQRxhxc',
  fDbUrl: 'https://angular-blog-545fb.firebaseio.com'
};
import { Environment } from './interface';
